import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsReducerCreator } from '../types';

const setGroupToDeleteReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | null>) => {
    state.groupToDelete = action.payload;
  });
};

export default setGroupToDeleteReducer;
